import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import KitoCircle from '../Circle';
import KitoClap from '../../../../assets/kitoBuddy/celebration-1.png';
import styles from '../styles.module.css';

function Milestone({ id, translateKey, options, initiallySelected = false }) {
  const { t } = useTranslation();

  const [selectedMilestone, setSelectedMilestone] = useState(initiallySelected ? 0 : null);
  return (
    <section key={id} className={styles.milestoneChecker__content}>
      <span className={`${styles.milestoneChecker__age} checkerAge`}>{t(`${translateKey}.title`)}</span>
      <article className={styles.milestoneChecker__section}>
        <div className={styles.milestoneChecker__gif} data-selected={selectedMilestone !== null}>
          <div className={styles.ellipsis}>
            {selectedMilestone !== null && options[selectedMilestone].gif.endsWith('.webm') ? (
              <video src={options[selectedMilestone].gif} autoPlay loop muted playsInline />
            ) : (
              <img
                src={selectedMilestone === null ? KitoClap : options[selectedMilestone].gif}
                alt={selectedMilestone === null ? 'kito-clap' : options[selectedMilestone].id}
              />
            )}
          </div>
          {selectedMilestone !== null && (
            <span className={styles.milestoneChecker__description}>
              {t(`${translateKey}.milestones.milestone${options[selectedMilestone].id}.description`)}
            </span>
          )}
        </div>
        <div className={styles.milestoneChecker__options}>
          {options.map((option, optionIndex) => {
            const angle = Math.PI * (optionIndex / (options.length - 1));

            return (
              <div key={option.id} className={styles.milestoneChecker__option} style={{ '--angle': `${angle}rad` }}>
                <KitoCircle
                  selected={selectedMilestone === optionIndex}
                  highlighted={selectedMilestone !== null && optionIndex === selectedMilestone + 1}
                  onClick={() => setSelectedMilestone(optionIndex)}
                  icon={option.icon}
                  tooltip={t(`${translateKey}.milestones.milestone${option.id}.title`)}
                  type={option.type}
                />
              </div>
            );
          })}
        </div>
      </article>
    </section>
  );
}

Milestone.propTypes = {
  id: PropTypes.number.isRequired,
  initiallySelected: PropTypes.bool,
  translateKey: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      icon: PropTypes.string.isRequired,
      gif: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['default', 'danger', 'warning']),
    })
  ).isRequired,
};

export default Milestone;
